import loginProvider from "../LoginProvider/LoginProvider";
import RequestProviderProps from "./RequestProvider.props";

export class RequestProvider {
    private props: RequestProviderProps;

    constructor(props: RequestProviderProps) {
        this.props = props;
    }

    getRequestOptions(): Record<string, unknown> {
        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
            'Accept': 'application/json', 
        }
    
        const token = loginProvider.getToken();
        if (token) {
            headers['jwtToken'] = token;
        }

        return {
            method: 'GET',
            headers: headers,
        }
    }

    postRequestOptions(body: unknown): Record<string, unknown> {
        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
        }
    
        const token = loginProvider.getToken();
        if (token) {
            headers['jwtToken'] = token;
        }

        return {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        };
    }

    async getData(url: string) {
        return await fetch(url, this.getRequestOptions())
            .then(function (response) {
                if (response.status === 200) {
                    try {
                        return response.json();
                    } catch (error) {
                        console.error(error);
                    }
                }
                return response;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    async postData(url: string, body: unknown) {
        return await fetch(url, this.postRequestOptions(body))
            .then(function (response) {
                return response;
            })
            .catch((err) => {
                console.error(err);
            });
    }
}

const requestProvider = new RequestProvider({});
export default requestProvider;
